
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.098 11.287v4.807h2.994v1.015H0v-5.822h1.098zM5.964 11.287v4.807h2.994v1.015H4.866v-5.822h1.098zM13.074 13.008h.973v4.1h-.956l-.05-.596c-.233.482-.873.715-1.331.723-1.215.009-2.113-.74-2.113-2.18 0-1.413.943-2.153 2.138-2.145.549 0 1.073.258 1.306.665l.033-.567zm-2.462 2.046c0 .782.54 1.248 1.215 1.248 1.596 0 1.596-2.487 0-2.487-.674 0-1.215.458-1.215 1.24zM20.051 12.892l-1.896 2.528h-.216l-1.855-2.536v4.233h-1.098v-5.822h1.264l1.822 2.504 1.82-2.504h1.255v5.822h-1.096v-4.225zM26.311 16.01H23.27l-.499 1.099h-1.189l2.61-5.822h1.197L28 17.109h-1.196l-.493-1.098zm-1.522-3.5l-1.08 2.478h2.162l-1.082-2.479z","fill":"#fff"}})])
          )
        }
      }
    